import { Component, Input, OnInit, OnDestroy, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vbo-events',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vbo-events.component.html',
  styleUrls: ['./vbo-events.component.less']
})
export class VboEventsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() siteId: string = "1AC0E12D-B0DA-4047-8A09-EEC91977AC62";
  @Input() page: string = "ListEvents";
  @Input() eid: number = 0;
  @Input() edid: number = 0;
  @Input() width: string = "100%";
  @Input() height: string = "400";
  @Input() bgColor: string = "transparent";

  // Unique container ID per component instance
  containerId: string;
  private isInitialized = false;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    // Generate unique ID
    this.containerId = `MyEvent`;
  }

  ngOnInit(): void {
    this.loadPluginScript();
  }

  ngAfterViewInit(): void {
    // Reinitialize plugin when view is ready (e.g., after navigation)
    setTimeout(() => {
      this.initPlugin();
    }, 100);
  }

  ngOnDestroy(): void {
    // Clean up the container content when component is destroyed
    const container = document.getElementById(this.containerId);
    if (container) {
      container.innerHTML = '';
    }
    this.isInitialized = false;
  }

  private loadPluginScript() {
    // Load script only once globally
    if (document.getElementById('vbo-plugin-script')) {
      this.initPlugin();
      return;
    }

    const script = this.renderer.createElement('script');
    script.src = 'https://plugin.vbotickets.com/_assets/js/plugin.js';
    script.type = 'text/javascript';
    script.id = 'vbo-plugin-script';
    script.async = false;

    script.onload = () => {
      this.initPlugin();
    };

    this.renderer.appendChild(document.body, script);
  }

  private initPlugin() {
      const container = document.getElementById(this.containerId);
      if (!container) {
        return;
      }

      // Clear previous content if any
      container.innerHTML = '';

      // Set global variables that the VBO plugin expects
      (window as any).SiteID   = this.siteId;
      (window as any).EID      = this.eid;
      (window as any).EDID     = this.edid;
      (window as any).Page     = this.page;
      (window as any).Width    = this.width;
      (window as any).Height   = this.height;
      (window as any).BgdColor = this.bgColor;

      // Call the VBO plugin's global function to load the widget
      if (typeof (window as any).LoadVBOPlugin === 'function') {
        // The plugin injects content based on where the script tag is located
        // Create a temporary script tag inside our container to trigger injection
        const triggerScript = this.renderer.createElement('script');
        triggerScript.type = 'text/javascript';
        triggerScript.textContent = '(function() { if (typeof LoadVBOPlugin === "function") LoadVBOPlugin(); })();';
        container.appendChild(triggerScript);
      }

      this.isInitialized = true;
  }
}
